import { IntlService, NumberFormatOptions } from '@progress/kendo-react-intl';

export class IntlHelper {
  public static formatDate = (intl: IntlService, date: Date) => {
    return intl.formatDate(date);
  };

  public static formatNumber = (intl: IntlService, number: number, format: NumberFormatOptions | string) => {
    return intl.formatNumber(number, format);
  };
}
